import { Close } from '@mui/icons-material';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import React, { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../store/actions';
import { makeStyles, withStyles } from '@mui/styles';
import { toastr } from 'react-redux-toastr';
import { i18n } from '../../translate/i18n';
import Lottie from 'lottie-react';
import fileLottie from '../../assets/lotties/file.json';
import { LoadingButton } from '@mui/lab';

const styles = {
  modalStyle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  avatar: {
    width: 60,
    height: 60,
    fontSize: 13
  },
  sendButton: {
    backgroundColor: 'green',
    color: '#fff',
    margin: '0.75rem 1rem'
  },
  closeButton: {
    position: 'absolute',
    fontSize: '1.1rem',
    top: 10,
    right: 10,
  },
  uploadFileBox: {
    width: '80%',
  },
  textBold: {
    fontWeight: 700,
    color: '#00000099'
  }
};

const useStyles = makeStyles(() => ({
	paper: { minWidth: "50vw" },
	root: {
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "grey"
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "grey"
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "grey",
			borderWidth: '1px'
    },
  }
}));


export const EquipmentsRegistrationLimitWarningModal = () => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const open = useSelector((state: any) => state.tenants.equipmentsLimitModalOpen);
  const tenant = useSelector((state: any) => state.auth.selectedAccess.tenant);
  const registeredEquipments = useSelector((state: any) => state.tenants.registeredEquipments);
  const loading = useSelector((state: any) => state.tenants.loading);

  const [messageSentSuccessfuly, setMessageSentSuccessfuly] = useState(false);

  const toggleEquipmentsLimitModal = useCallback(() => dispatch(actions.toggleEquipmentsLimitModal()), [])

  const notifyAccountables = useCallback(() => dispatch(actions.notifyAccountables()) as unknown as Promise<string>, [])

  const handleNotifyAccountables = () => {
    notifyAccountables()
      .then((result) => {
        if (result === 'success') {
          toastr.success(
            i18n.t('equipmentsRegistrationLimitWarning.notificationSuccessTitle'),
            i18n.t('equipmentsRegistrationLimitWarning.notificationSuccessText')
          );
          setMessageSentSuccessfuly(true);
        }
      })
      .catch((result) => {
        if (result === 'error') {
          toastr.error(
            i18n.t('equipmentsRegistrationLimitWarning.notificationErrorTitle'),
            i18n.t('equipmentsRegistrationLimitWarning.notificationErrorText')
          );
          setMessageSentSuccessfuly(false);
        }
      })
  }

  const equipmentsRegistrationLimit = tenant?.equipmentsRegistrationLimit;


  if (!equipmentsRegistrationLimit || registeredEquipments === null) {
    return <></>
  }

  const {
    maxEquipmentsTolerated = 0,
    maxEquipments = 0,
    tolerance = 0
  } = equipmentsRegistrationLimit;

  let reachedPercentage = (maxEquipments > 0) ? parseFloat((registeredEquipments/maxEquipments * 100).toFixed(2)) : 100;
  reachedPercentage = reachedPercentage > 100 ? 100 : reachedPercentage;

  let reachedPercentageOverLimit = (registeredEquipments > maxEquipments) ? parseFloat(((registeredEquipments - maxEquipments)/(maxEquipmentsTolerated - maxEquipments) * 100).toFixed(2)) : 0;
  reachedPercentageOverLimit = reachedPercentageOverLimit > 100 ? 100 : reachedPercentageOverLimit

  const DialogTitleCustom = withStyles(styles as any)((props: any) => {
    const { children, classes, onClose, ...other } = props;

    return (
      <DialogTitle className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={onClose}
              size="large">
            <Close />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  });

  const BarWithinLimit = (
    <Box sx={{background: '#eee', position: 'relative', borderRadius: '2px 0px 0px 2px', width: `${100 - tolerance}%`, height: '10px'}}>
      <Box
        sx={{
          background: 'green',
          position: 'absolute',
          left: 0,
          borderRadius: '2px 0px 0px 2px',
          width: `${reachedPercentage}%`,
          height: '100%'
        }}
      />
    </Box>
  );

  const BarOverLimit = (
    <Box sx={{background: '#eee', position: 'relative', borderRadius: '0px 2px 2px 0px', width: `${tolerance}%`, height: '10px', marginLeft: '2px'}}>
      <Box
        sx={{
          background: '#d32f2f',
          position: 'absolute',
          left: 0,
          borderRadius: '0px 2px 2px 0px',
          width: `${reachedPercentageOverLimit}%`,
          height: '100%'
        }}
      />
    </Box>
  )


  const content = (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      gap: 5,
      position: 'relative'
    }}>

      <Box sx={{display: 'flex', flexDirection: 'column'}}>
        <Typography>
          <span style={styles.textBold}>{registeredEquipments}</span>/{maxEquipments} {i18n.t('equipmentsRegistrationLimitWarning.registeredEquipments')}
        </Typography>
        <Box sx={{display: 'flex', alignItems: 'center', width: '100%'}}>
          {BarWithinLimit}
          {BarOverLimit}
        </Box>
      </Box>

      <Typography>
        {`${i18n.t('equipmentsRegistrationLimitWarning.reachedInfoPrefix')}`} <span style={styles.textBold}>{reachedPercentage}% {`${i18n.t('equipmentsRegistrationLimitWarning.reachedInfoSuffix')}`}</span>, {`${i18n.t('equipmentsRegistrationLimitWarning.upgradeInfo')}`}:
      </Typography>
  
      <Box sx={{display: 'flex', flexDirection: 'column'}}>
        {tenant?.accountables?.length > 0 ? tenant.accountables.map((obj: any, index: number) => (
          <Typography key={index}>
            <span style={styles.textBold}>{obj.name}</span> - {obj.email}
          </Typography>
        ))
        : <Typography>
            {`${i18n.t('equipmentsRegistrationLimitWarning.noAccountables')}`}
          </Typography>}
      </Box>
    </Box>
  )

  const notificationFeedback = (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 1,
      position: 'relative'
    }}>
      <Lottie style={{ height: '90px', marginBottom: '20px' }} animationData={fileLottie} loop={true} />

      <Typography sx={styles.textBold} variant="h6">
        {`${i18n.t('equipmentsRegistrationLimitWarning.messageSentTitle')}`}
      </Typography>

      <Typography>
        {`${i18n.t('equipmentsRegistrationLimitWarning.messageSentText')}`}
      </Typography>
    </Box>
  )

  return (
    <Dialog
      style={styles.modalStyle}
      maxWidth="sm"
      scroll='body'
      open={open}
      onClose={() => { toggleEquipmentsLimitModal(); setMessageSentSuccessfuly(false); }}
    >
      <DialogTitleCustom id="customized-dialog-title" onClose={() => { toggleEquipmentsLimitModal(); setMessageSentSuccessfuly(false); }}>
          <div style={{ fontWeight: 'bold' }}>{`${i18n.t('equipmentsRegistrationLimitWarning.modalTitle')}`}</div>
      </DialogTitleCustom>

      <DialogContent dividers>
        {messageSentSuccessfuly ? notificationFeedback : content}
      </DialogContent>

      {!messageSentSuccessfuly && (
        <DialogActions>
            <LoadingButton
              variant="contained"
              onClick={() => handleNotifyAccountables()}
              style={styles.sendButton}
              disabled={loading}
              loading={loading}
              loadingPosition="start"
              sx={{opacity: loading ? 0.6 : 1}}
            >
              <Typography sx={{marginLeft: loading ? 3: 0}}>
                {`${i18n.t('equipmentsRegistrationLimitWarning.contactAccountables')}`}
              </Typography>
            </LoadingButton>
        </DialogActions>
      )}
    </Dialog>
  )
}